import { Verified } from './verified';

export default Verified;
